import makeStyles from '@mui/styles/makeStyles';
import portalSettingsManager from "utils/portalSettingsManager";

export const useStyles = makeStyles(() => ({
  card: {
    position: "relative",
    borderRadius: "12px",
    boxShadow: "0px 8px 24px -4px rgba(24, 39, 75, 0.08), 0px 6px 12px -6px rgba(24, 39, 75, 0.12)",
    "&:focus-within": {
      outline: `2px solid ${portalSettingsManager?.application?.common?.ibfThemeColor}`,
    },
    align: "center",
  },
  media: {
    minWidth: "270px",
    minHeight: "260px",
  },

  content: {
    fontSize: "16px",
    fontWeight: "bold",
    textAlign: "left",
    bottom: 0,
    width: "100%",
    padding: "5px 0px 5px 15px",
  },
  contentHeader: {
    fontSize: "16px",
    fontWeight: 700,
    textAlign: "left",
    padding: "0px",
  },
}));
